const de = {
    aboutUs: 'Über uns',
    contact: 'Kontakt',
    product: 'Produkt',
    shop: 'Shop',
    size: 'Größe',
    shoppingBag: 'Einkaufskorb',
    quantity: 'Menge',
    price: 'Preis',
    paymentMethod: 'Zahlungsmethode',
    subTotal: 'Zwischensumme',
    shipping: 'Lieferung',
    total: 'Gesamt',
    checkout: 'Kasse',
    free: 'kostenlos',
    thankYouHeading: 'Vielen Dank für Ihren Einkauf',
    thankYouText: 'Ihre bestellten Produkte werden in Kürze bei Ihnen eintreffen.',
};
const en = {
    aboutUs: 'About us',
    contact: 'Contact',
    product: 'Product',
    shop: 'Shop',
    size: 'Size',
    shoppingBag: 'Shopping bag',
    quantity: 'Quantity',
    price: 'Price',
    paymentMethod: 'Payment Method',
    subTotal: 'Subtotal',
    shipping: 'Shipping',
    total: 'Total',
    checkout: 'Checkout',
    free: 'free',
    thankYouHeading: 'Thanks for your purchase',
    thankYouText: 'Your ordered products will reach you shortly.',
};
const it = {
    aboutUs: 'Chi siamo',
    contact: 'Contatto',
    product: 'Prodotto',
    shop: 'Negozio',
    size: 'Dimensione',
    shoppingBag: 'Carrello Della Spesa',
    quantity: 'Quantità',
    price: 'Prezzo totale',
    paymentMethod: 'Metodo di pagamento',
    subTotal: 'Subtotale',
    shipping: 'Spedizione',
    total: 'Totale',
    checkout: 'Checkout',
    free: 'free',
    thankYouHeading: 'grazie per il tuo acquisto',
    thankYouText: 'I prodotti ordinati ti raggiungeranno a breve.',
};
const nl = {
    aboutUs: 'Over ons',
    contact: 'Contact',
    product: "Product",
    shop: 'Winkel',
    size: "Maat",
    shoppingBag: "Winkelwagen",
    quantity: "Hoeveelheid",
    price: "Totale Prijs",
    paymentMethod: "Betaalmethode",
    subTotal: "Subtotaal",
    shipping: "Verzending",
    total: "Totaal",
    checkout: "Kassa",
    free: 'gratis',
    thankYouHeading: 'Tak for dit køb',
    thankYouText: 'Dine bestilte produkter vil nå dig inden længe.',
};
const fr = {
    aboutUs: "A propos de nous",
    contact: 'Contact',
    product: 'Produit',
    shop: 'Boutique',
    size: "Taille",
    shoppingBag: 'Chariot',
    quantity: 'Quantité',
    price: "Prix total",
    paymentMethod: "Mode de paiement",
    subTotal: "Sous-total",
    shipping: 'Expédition',
    total: "Total",
    checkout: 'Checkout',
    free: 'gratuit',
    thankYouHeading: 'Merci pour votre achat',
    thankYouText: 'Vos produits commandés vous parviendront sous peu.',
};
export const localizedTexts = {
    de,
    en,
    it,
    nl,
    fr
};
